(()=>{
  const init=()=>{
    const film=document.querySelector('[data-am-wait-film]');
    if(!film||film.dataset.ready)return;
    const roots=Array.from(document.querySelectorAll('[data-sb-root],[data-amf-root]'));
    if(!roots.length)return;
    film.dataset.ready='true';
    const video=film.querySelector('[data-am-film-video]');
    const sound=film.querySelector('[data-am-film-sound]');
    let owner=null,slot=null,timer=0,reviews=null,reviewHome=null;
    const restoreReviews=()=>{
      if(reviews&&reviewHome?.parentNode)reviewHome.replaceWith(reviews);
      reviews=null;reviewHome=null;film.removeAttribute('data-mode');
      if(video.hidden)video.hidden=false;
    };
    const visible=el=>!!el&&!el.closest('[hidden]')&&getComputedStyle(el).display!=='none';
    const activeRoot=()=>roots.find(root=>{
      if(!root.isConnected)return false;
      if(root.matches('[data-sb-root]'))return visible(root.querySelector('[data-screen="loading"]'))&&visible(root.querySelector('[data-wait]'))&&!root.querySelector('[data-error]')?.textContent.trim();
      return root.dataset.currentStep==='5'&&visible(root.querySelector('[data-amf-step="5"]'));
    });
    const play=()=>{const attempt=video.play();if(attempt?.catch)attempt.catch(()=>{});};
    const reveal=()=>{
      timer=0;
      if(!owner||activeRoot()!==owner)return;
      if(!video.getAttribute('src'))video.src=video.dataset.src;
      restoreReviews();video.muted=true;sound.hidden=false;
      try{video.currentTime=0;}catch{}
      film.hidden=false;slot.classList.add('am-wait-film-active');
      play();
    };
    const stop=()=>{
      clearTimeout(timer);timer=0;
      if(!film.hidden)film.hidden=true;
      slot?.classList.remove('am-wait-film-active');
      restoreReviews();
      video.pause();owner=null;slot=null;
    };
    const sync=()=>{
      const next=activeRoot();
      if(!next){if(owner)stop();return;}
      if(owner===next)return;
      stop();owner=next;
      slot=next.matches('[data-sb-root]')?next.querySelector('[data-wait]'):next.querySelector('[data-amf-step="5"]');
      const anchor=slot.querySelector('.sb-clock,.amf__count');
      if(anchor)anchor.after(film);else slot.prepend(film);
      const elapsed=next.querySelector('[data-elapsed]')?.textContent.trim().split(':').map(Number);
      const seconds=elapsed?.length===2&&elapsed.every(Number.isFinite)?elapsed[0]*60+elapsed[1]:0;
      timer=setTimeout(reveal,Math.max(0,5000-seconds*1000));
    };
    video.addEventListener('ended',()=>{
      if(!owner||activeRoot()!==owner||film.hidden||reviews)return;
      const existing=owner.querySelector('.sb-reviews');
      if(!existing)return;
      reviews=existing;reviewHome=document.createElement('span');reviewHome.hidden=true;
      existing.before(reviewHome);film.append(existing);film.dataset.mode='reviews';
      video.hidden=true;sound.hidden=true;
    });
    sound.addEventListener('click',()=>{video.muted=false;play();sound.hidden=true;});
    video.addEventListener('volumechange',()=>{sound.hidden=film.dataset.mode==='reviews'||(!video.muted&&video.volume>0);});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});
    roots.forEach(root=>new MutationObserver(sync).observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden','data-current-step']}));
    sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
